<div class="progress-container" [style.border-color]="getBorderColor()">
  <div
    class="progress-bar"
    [style.width]="valuePercentEven() + '%'"
    [style.background-color]="getBackgroundColor()"></div>
  <span class="text">{{ valueIcf() }}</span>
</div>
